import assertNever from "../../../../global/assetNever";
import {ListViewFilterControlElementType} from "../../../enums/listViews/listViewFilterControlElementType";
import {ListViewFilterLayoutElementType} from "../../../enums/listViews/listViewFilterLayoutElementType";
import {ListViewFilterElementType} from "../../../enums/listViews/listViewFilterElementType";

export default class ListViewFilterElementDefinition {
  static getComponent(filterType: ListViewFilterElementType): string {
    switch (filterType) {
      case ListViewFilterControlElementType.Dropdown:
        return 'filter-element-dropdown';
      case ListViewFilterControlElementType.SearchBar:
        return 'filter-element-search-bar';
      case ListViewFilterControlElementType.DateRange:
        return 'filter-element-date-range';
      case ListViewFilterControlElementType.Toggle:
        return 'filter-element-toggle';
      case ListViewFilterLayoutElementType.Grid:
        return 'filter-element-grid';
      case ListViewFilterLayoutElementType.Stack:
        return 'filter-element-stack';
      default:
        assertNever(filterType);
    }
  }

  static getDisplayName(filterType: ListViewFilterElementType): string {
    switch (filterType) {
      case ListViewFilterControlElementType.Dropdown:
        return 'Single/multi-select';
      case ListViewFilterControlElementType.SearchBar:
        return 'Search Bar';
      case ListViewFilterControlElementType.DateRange:
        return 'Date Range';
      case ListViewFilterControlElementType.Toggle:
        return 'Toggle';
      case ListViewFilterLayoutElementType.Grid:
        return 'Grid';
      case ListViewFilterLayoutElementType.Stack:
        return 'Stack';
      default:
        assertNever(filterType);
    }
  }

  static getIcon(filterType: ListViewFilterElementType): string {
    switch (filterType) {
      case ListViewFilterControlElementType.Dropdown:
        return 'dropdown';
      case ListViewFilterControlElementType.SearchBar:
        return 'search-bar';
      case ListViewFilterControlElementType.DateRange:
        return 'date-range';
      case ListViewFilterControlElementType.Toggle:
        return 'toggle';
      case ListViewFilterLayoutElementType.Grid:
        return 'grid';
      case ListViewFilterLayoutElementType.Stack:
        return 'stack';
      default:
        assertNever(filterType);
    }
  }

  static getComponentClass(filterType: ListViewFilterElementType): string {
    return `lv-${ListViewFilterElementDefinition.getComponent(filterType)}`;
  }

  static getControlGroups(): { name: string, icon: string, type: ListViewFilterElementType }[] {
    return [
      {
        name: ListViewFilterElementDefinition.getDisplayName(ListViewFilterControlElementType.Dropdown),
        icon: ListViewFilterElementDefinition.getIcon(ListViewFilterControlElementType.Dropdown),
        type: ListViewFilterControlElementType.Dropdown,
      },
      {
        name: ListViewFilterElementDefinition.getDisplayName(ListViewFilterControlElementType.SearchBar),
        icon: ListViewFilterElementDefinition.getIcon(ListViewFilterControlElementType.SearchBar),
        type: ListViewFilterControlElementType.SearchBar,
      },
      {
        name: ListViewFilterElementDefinition.getDisplayName(ListViewFilterControlElementType.DateRange),
        icon: ListViewFilterElementDefinition.getIcon(ListViewFilterControlElementType.DateRange),
        type: ListViewFilterControlElementType.DateRange,
      },
      {
        name: ListViewFilterElementDefinition.getDisplayName(ListViewFilterControlElementType.Toggle),
        icon: ListViewFilterElementDefinition.getIcon(ListViewFilterControlElementType.Toggle),
        type: ListViewFilterControlElementType.Toggle,
      },
    ];
  }

  static getLayoutGroups(): { name: string, icon: string, type: ListViewFilterLayoutElementType }[] {
    return [
      {
        name: ListViewFilterElementDefinition.getDisplayName(ListViewFilterLayoutElementType.Grid),
        icon: ListViewFilterElementDefinition.getIcon(ListViewFilterLayoutElementType.Grid),
        type: ListViewFilterLayoutElementType.Grid,
      },
      {
        name: ListViewFilterElementDefinition.getDisplayName(ListViewFilterLayoutElementType.Stack),
        icon: ListViewFilterElementDefinition.getIcon(ListViewFilterLayoutElementType.Stack),
        type: ListViewFilterLayoutElementType.Stack,
      },
    ];
  }
  static getFilteringComponent(filterType: ListViewFilterElementType): string {
    switch (filterType) {
      case ListViewFilterControlElementType.Dropdown:
        return 'filter-dropdown';
      case ListViewFilterControlElementType.SearchBar:
        return 'filter-search-bar';
      case ListViewFilterControlElementType.DateRange:
        return 'filter-date-range';
      case ListViewFilterControlElementType.Toggle:
        return 'filter-toggle';
      case ListViewFilterLayoutElementType.Grid:
        return 'filter-grid';
      case ListViewFilterLayoutElementType.Stack:
        return 'filter-stack';
      default:
        assertNever(filterType);
    }
  }

  static getDefaultPropertyFilterOptionId(filterType: ListViewFilterElementType): string | number {
    return null // just return null for now
    // switch(filterType) {
    // case ListViewFilterControlElementType.Dropdown:
    //   return SelectOptionString.None
    // case ListViewFilterControlElementType.DateRange:
    //   return DefaultDates.None
    // default:
    //   return null;
    // }
  }
}